import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';
import Pricing from './components/Pricing';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTABand from './components/CTABand';
import Footer from './components/Footer';
import OrderPage from './components/OrderPage';
import DashboardLayout from './components/Dashboard/DashboardLayout';

function HomePage() {
  return (
    <main>
      <Hero />
      <StatsBar />
      <HowItWorks />
      <Services />
      <Pricing />
      <WhyUs />
      <Testimonials />
      <FAQ />
      <CTABand />
    </main>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/dashboard/*" element={<DashboardLayout />} />
        <Route path="*" element={
          <>
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/order" element={<OrderPage />} />
            </Routes>
            <Footer />
          </>
        } />
      </Routes>
    </Router>
  );
}
